import { useState } from "react";
import { useSelector } from "react-redux";

import { Grid } from "@material-ui/core";

import { GRAPH_UNITS } from "../../../dashboard/constants";
import { ActionTimeGroup } from "../../../../components/actionTimeTimeGroup";
import { ProductionTotal } from "./ProductionTotal";
import { InstalledCapacity } from "./InstalledCapacity";
import { ProductionOverTime } from "./ProductionOverTime";
import { DynamicMicroGrid } from "./DynamicMicroGrid";
import { GridBalancing } from "./GridBalancing";
import { IncreasePowerRevenues } from "./IncreasePowerRevenues";
import { InstalledAssetsWithRecommendations } from "./InstalledAssetsWithRecommendations";

export const OverviewTab = () => {
  const [toggleFilter, setToggleFilter] = useState(GRAPH_UNITS.kwh);
  const { period, startDate, endDate } = useSelector((state) => state.selectedPeriods);

  return (
    <div>
      <ActionTimeGroup
        hideIntegrateBtn
        showToggleFilter
        toggleFilter={toggleFilter}
        setToggleFilter={setToggleFilter}
      />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InstalledAssetsWithRecommendations />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ProductionTotal
            period={period}
            startDate={startDate}
            endDate={endDate}
            graphUnit={toggleFilter}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InstalledCapacity
            period={period}
            startDate={startDate}
            endDate={endDate}
            graphUnit={toggleFilter}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ProductionOverTime
            period={period}
            startDate={startDate}
            endDate={endDate}
            showByFilter={true}
            graphUnit={toggleFilter}
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <DynamicMicroGrid />
        </Grid>
        <Grid item xs={12} sm={4}>
          <GridBalancing />
        </Grid>
        <Grid item xs={12}>
          <IncreasePowerRevenues />
        </Grid>
      </Grid>
    </div>
  );
};
